import { Link } from 'react-router-dom';
import styles from './RecipeCard.module.css';

const DIFF_COLOR  = { Easy: '#4caf87', Medium: '#f0a030', Hard: '#e05050' };
const DIFF_BG     = { Easy: 'rgba(76,175,135,0.15)', Medium: 'rgba(240,160,48,0.15)', Hard: 'rgba(224,80,80,0.15)' };

export default function RecipeCard({ recipe, style = {}, featured = false }) {
  return (
    <Link
      to={`/baking/${recipe.slug}`}
      className={`${styles.card} ${featured ? styles.cardFeatured : ''}`}
      style={{ animationDelay: style.animationDelay || '0s' }}
    >
      {/* Emoji splash background */}
      <div className={styles.splash} style={{ background: recipe.color }}>
        <div className={styles.splashEmoji}>{recipe.emoji}</div>

        {/* Hover overlay */}
        <div className={styles.overlay}>
          <span className={styles.overlayText}>View Recipe →</span>
        </div>

        {/* Top badges */}
        <div className={styles.badges}>
          <span
            className={styles.diffBadge}
            style={{ color: DIFF_COLOR[recipe.difficulty], background: DIFF_BG[recipe.difficulty] }}
          >
            {recipe.difficulty}
          </span>
          {recipe.featured && (
            <span className={styles.featBadge} style={{ background: recipe.accentColor }}>
              ★ Featured
            </span>
          )}
        </div>

        {/* Time pill bottom-right */}
        <span className={styles.timePill}>⏱ {recipe.time}</span>
      </div>

      {/* Body */}
      <div className={styles.body}>
        <div className={styles.catRow}>
          <span className={styles.cat} style={{ color: recipe.accentColor }}>
            {recipe.category}
          </span>
          <span className={styles.servings}>🍽 {recipe.servings} servings</span>
        </div>

        <h3 className={styles.title}>{recipe.title}</h3>
        <p className={styles.desc}>{recipe.description}</p>

        <div className={styles.tags}>
          {recipe.tags.slice(0, 3).map(t => (
            <span key={t} className={styles.tag}>#{t}</span>
          ))}
        </div>

        <div className={styles.footer}>
          <span className={styles.date}>{recipe.date}</span>
          <span className={styles.cta} style={{ color: recipe.accentColor }}>
            Cook this →
          </span>
        </div>
      </div>

      {/* Accent bar at bottom */}
      <div className={styles.accentBar} style={{ background: recipe.accentColor }} />
    </Link>
  );
}
